
import http from '../.././http';
/**
 * 用户管理接口
 */
// 新增、修改
export function saveOrUpdateUser(params) {
  return http.post('User/SaveUser', params);
}
/**
 * 修改密码
 * @param {} params
 * @returns
 */
export function UpdatePwd(params) {
  return http.post('User/UpdatePwd', params);
}
// 列表
export function accountList(params) {
  return http.get('User/GetUserPage', { params });
}
// 修改状态
export function updateStatusUser(params) {
  return http.post('User/updateStatusUser', params);
}
// 根据ID获得实体
export function userDetail(params) {
  return http.get('User/GetUser', { params });
}
// 删除
export function deleteUser(params) {
  return http.post('User/DeleteUser', params, { headers: { 'Content-Type': 'application/json' }});
}
// 批量删除
export function deleteUserList(params) {
  return http.post('User/deleteUserList', params, { headers: { 'Content-Type': 'application/json' }});
}
// 所有租户
export function company(params) {
  return http.get('sBase/findCompanylist', { params });
}
